import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, NgForm, Validators, FormControl } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { ProjectService } from 'src/app/_services/project.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-import',
  templateUrl: './import.component.html',
  styleUrls: ['./import.component.scss']
})
export class ImportComponent implements OnInit {

  ImportForm:UntypedFormGroup;
  projectName: any;     
  submitted= false;
  url: string;
  title: any;
  projectId: any;
  parentTestDataId: any;
  pName: string='';
  Formfile: any;
  projectdata: any;
  fileType: string;
  constructor(@Inject(MAT_DIALOG_DATA) public data,
  private formBuilder: UntypedFormBuilder,
  private http: HttpClient,
  private project: ProjectService,
  private toastrService: ToastrService,
  public dialogRef: MatDialogRef< ImportComponent>) { 

    this.url = environment.baseUrl;
    
  }

  upload(files: File[]){
    this.Formfile=files[0];
    //pick from one of the 4 styles of file uploads below
    //console.log(this.Formfile, files[0].name);
    this.pName = files[0].name;
    this.pName = this.pName.substring(0, this.pName.length - 4);
    this.fileType = files[0].type
    console.log(files[0].type);
    
    //console.log(this.pName);

// this.prjImportFile(files, this.pName);

  }
  ngOnInit() {
    this.loadForm();
  }


  loadForm(){
    this.ImportForm = this.formBuilder.group({
      
      projectName:['',Validators.required]
    })
  }
get f(){
  return this.ImportForm.controls;
}
  ImportProject(){
    this.submitted = true;
    if(this.fileType!='application/x-zip-compressed' && this.fileType!='application/zip'){
      this.toastrService.clear();
      this.toastrService.error('Only zip files are supported');
      return;
    }
    if(this. ImportForm.invalid){
      return;
    }
    var objFormval = this.ImportForm.value;
    //console.log(this.Formfile,objFormval.projectName)
    this.prjImportFile(this.Formfile,objFormval.projectName)
  }
  prjImportFile(file, projectName) {
    //console.log(file);
    // var project = new Object();
    // projectName = pName;
    var fd = new FormData();
    fd.append('file', file);
    var uploadUrl = this.url+'/HuLoopRest/huloop/projectImport/upload/' + projectName;
    this.toastrService.clear();
    this.toastrService.success('Uploading project...&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i class="fa fa-circle-o-notch fa-spin"></i></i>', null, {
        extendedTimeOut: 0,
        timeOut: 0,
        enableHtml: true
    });
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'multipart/form-data');
    headers = headers.append('enctype', 'multipart/form-data')
    this.http.post(uploadUrl, fd, {headers
    }).subscribe(
      (data)=>{
        this.closeDialog();

 //console.log(data,'___________');
 this.toastrService.clear();
 this.project.loadSuggestion.next(true);
 this.toastrService.success('Project Imported Succesfully');
 this.project.getAllProjects().subscribe(
  (data) => {
this.projectdata = data['project'];
// TreeData = this.projectdata;
// this.dataSource = this.projectdata;
//console.log('[project]',this.projectdata);
this.project.sendProjectData(this.projectdata);
this.dialogRef.close(true);
});
      }
    );
}
  
closeDialog() {
  this.dialogRef.close(false);
}


}
